import cn from 'classnames';
import { IAdminPayment } from 'types';
import { AdminListRowCell } from '../AdminListRowCell';
import { StyledAdminPaymentHistoryListRow } from './styles';

export interface IPaymentHistoryListRowProps {
  payment: IAdminPayment;
  onChange: (payment: IAdminPayment) => void;
}

type PaymentFieldMap = Record<
    string,
    (payment: IAdminPayment, onChange?: (payment: IAdminPayment) => void) => React.ReactNode
>;

export const paymentFieldMap: PaymentFieldMap = {
  id: (payment) => payment.id,
  hashId: (payment) => payment.hashId,
  status: (payment, onChange) => (
      <select
          className="status-select"
          value={payment.status}
          onChange={(e) =>
              onChange && onChange({ ...payment, status: e.target.value })
          }
      >
        <option value="UNCONFIRMED">UNCONFIRMED</option>
        <option value="CONFIRMED">CONFIRMED</option>
      </select>
  ),
  createdAt: (payment) => payment.createdAt,
  updatedAt: (payment) => payment.updatedAt,
};

export const AdminPaymentHistoryListRow = ({ payment, onChange }: IPaymentHistoryListRowProps) => {
  return (
      <StyledAdminPaymentHistoryListRow>
        {Object.entries(paymentFieldMap).map(([title, valueGetter]) => (
            <div key={title} className={cn('admin-list-cell-container', title.toLowerCase())}>
              <AdminListRowCell>
                {valueGetter(payment, onChange)}
              </AdminListRowCell>
            </div>
        ))}
      </StyledAdminPaymentHistoryListRow>
  );
};
